import {
  GeckoComponentDataFrame,
  GeckoInspection,
  GeckoSource,
  GeckoView,
  PredictedInspectionType,
} from 'types'

export function isInspectionThicknessCDF(cdf: GeckoComponentDataFrame) {
  return (
    cdf.data.params.view === GeckoView.Thickness &&
    cdf.data.params.source !== GeckoSource.Projection &&
    cdf.data.params.source !== GeckoSource.TMin &&
    cdf.data.params.source !== GeckoSource.Nominal
  )
}

export function isPredictedThicknessCDF(
  cdf: GeckoComponentDataFrame,
  inspections: ReadonlyArray<GeckoInspection>
) {
  return (
    cdf.data.params.view === GeckoView.Thickness &&
    cdf.data.params.source === GeckoSource.Projection &&
    isPredictedCDF(cdf, inspections)
  )
}

// Returns true if this CDF is tagged to a predicted inspection, making it a predicted CDF
export function isPredictedCDF(
  cdf: GeckoComponentDataFrame,
  inspections: ReadonlyArray<GeckoInspection>
): boolean {
  const inspectionId = cdf.tags.inspection
  if (!inspectionId) return false

  const inspection = inspections.find((insp) => insp.id === inspectionId)
  if (!inspection) return false

  return PredictedInspectionType.includes(
    inspection.data.inspection_type as PredictedInspectionType
  )
}
